export default "__VITE_ASSET__CL7jUnN5__"